import { Diamond } from "lucide-react";

export default function Marquee({ items, slow = false, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className={`overflow-hidden border-y hairline-gold py-5 ${className}`}
    >
      <div className={`marquee-track flex items-center ${slow ? "slow" : ""}`}>
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 pr-8 text-sm uppercase tracking-[0.35em] text-slate-500 whitespace-nowrap"
          >
            {item}
            <Diamond className="h-2.5 w-2.5 text-gold/60" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}
